module.exports = __webpack_public_path__ + "img/live_casino.043d25dc.png";